module.exports = __webpack_public_path__ + "static/media/23_Bild_4_WHEEL_Team_HSR-Enhanced_AlessandroDellaBella_115.2dca4b37.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle23/23_Bild_4_WHEEL_Team_HSR-Enhanced_AlessandroDellaBella_115.jpg
 ** module id = 168
 ** module chunks = 0
 **/